export const Domain = {
  TAA: "0",
  TAC: "1",
};
